import { connect } from "react-redux";
import React from "react";
import Button from '../Button';
import FieldRow from '../FieldRow';
import FieldPasswordRow from '../FieldPasswordRow';
import * as validators from '../../utils/validation';
import { formatDateDmy } from "../../utils/dates";
import SignUpManualIEOptions from "./SignUpManualIEOptions";
import styled from "styled-components";
import SignUpTermsCheckbox from "./SignUpTermsCheckbox";
import ChoicesGroupLabel from "../forms/ChoicesGroupLabel";
import FieldValidationMessage from "../forms/FieldValidationMessage";
import { formatIeCode } from "../../utils/strings";
import PaymentSidebar from "../checkout/PaymentSidebar";
import { paymentMethods } from "../../actions/creators/checkout/payment";
import { CHECKOUT_CONTEXT_SIGN_UP } from "../../actions/creators/checkout";
import { getIeSignUpOptions, getIeSignUpPaymentGateway } from "../../reducers";
import { fetchIeSignUpOptions } from "../../actions/creators/ie";

const LoyaltyOptionsRow = styled.div`
    & .form-group.form-group--label-helper {
        padding-top: 0;
        margin-bottom: 1em;

        & .form-group.form-group--label-helper label {
            display: none;
        }
    }
`;

const LoyaltySubOptionRow = styled.div`
    margin-bottom: 2em;
    label { display: none; }
`

const BenefitRow = styled.div`
    cursor: pointer;
    position: relative;

    &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .fal { top: 10px; }
`;

const fields:{ [key: string]: any} = {
    email: {
        label: "Email", required: true, validationFns: [validators.validateEmail], validationMessage: 'Ingresa un email válido.',
        type: 'email',
        disabled: true
    },
    firstName: {label: "Nombres", required: true, validationFns: [validators.validateNotEmpty], validationMessage: 'Ingresa tu nombre.'},
    lastName: {label: "Apellido paterno", required: true, validationFns: [validators.validateNotEmpty], validationMessage: 'Ingresa tu apellido paterno.'},
    motherLastName: {label: "Apellido materno", required: true, validationFns: [validators.validateNotEmpty], validationMessage: 'Ingresa tu apellido materno.'},
    phone: {
        label: "Teléfono",
        required: true,
        validationFns: [validators.validateNotEmpty, validators.validateNumber10Digits],
        validationMessage: 'Ingresa un número de teléfono de 10 dígitos.',
        type: 'number'
    },
    birthDate: {
        label: "Fecha de nacimiento",
        required: true,
        validationFns: [validators.validateBirthDate, validators.isAtLeast18],
        validationMessage: ['Ingresa tu fecha de nacimiento.', 'Debes ser mayor de 18 años.'],
        placeholder: 'dd/mm/yyyy',
        formatterFn: formatDateDmy,
    },
    gender: {
        label: "Género", required: true, validationFns: [validators.validateNotEmpty], validationMessage: 'Selecciona tu género.',
        placeholder: 'Selecciona tu género',
        choices: [
            {id: 'female', name: 'Femenino'},
            {id: 'male', name: 'Masculino'},
            {id: 'non-binary', name: 'No binarie'},
            {id: 'no-answer', name: 'Prefiero no decir'},
        ],
        expanded: true
    },
    password: {
        label: "Contraseña", required: true, validationFns: [validators.validatePassword], validationMessage: 'Ingresa una contraseña segura.',
        type: 'password-row',
    },
    passRepeat: {
        label: "Repetir contraseña", required: true, validationFns: [validators.validateNotEmpty], validationMessage: 'Repite la contraseña.',
        type: 'password'
    }
}

interface Props {
    apple?: boolean;
    info: any;
    ieOptions: any[];
    isSignUpOptionRequired: boolean;
    paymentGateway?: string;
    validationError?: string;
    onSubmit: (data: any) => void;
    fetchIeSignUpOptions: (params: { cinemaId: string }) => void;
}

interface State {
    [key: string]: any;
}

class SignUpManualUserInfo extends React.Component<Props, State> {

    constructor(props) {
        super(props);
    
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onIEOptionSelect = this.onIEOptionSelect.bind(this);
        this.onCinemaChange = this.onCinemaChange.bind(this);
        this.onIEOptionsClose = this.onIEOptionsClose.bind(this);
        this.onIEOptionsOpen = this.onIEOptionsOpen.bind(this);
        this.onTermsChange = this.onTermsChange.bind(this);
        this.userIsLoyaltyMember = this.userIsLoyaltyMember.bind(this);
        this.validateLoyaltyCardNumber = this.validateLoyaltyCardNumber.bind(this);
        this.onLoyaltyCardNumberChange = this.onLoyaltyCardNumberChange.bind(this);
        this.onHasLoyaltyAccountChange = this.onHasLoyaltyAccountChange.bind(this);
        this.getRegisterParams = this.getRegisterParams.bind(this);
        this.onPaymentCancel = this.onPaymentCancel.bind(this);
    
        this.state = {
            email: {value: this.props.info.email, valid: null},
            firstName: {value: this.props.info.first_name || '', valid: null},
            lastName: {value: this.props.info.f_last_name || '', valid: null},
            motherLastName: {value: this.props.info.m_last_name || '', valid: null},
            phone: {value: this.props.info.phone || '', valid: null},
            birthDate: {value: this.props.info.birth_date || '', valid: null},
            gender: {value: this.props.info.gender || '', valid: null},
            cinema: {value: this.props.info.cinema_id ? this.props.info.cinema_id + '' : '', valid: null},
            password: {value: '', valid: null},
            passRepeat: {value: '', valid: null},
            sent: false,
            disagree: false,
            ieOption: {value: null, id: null, valid: null},
            ieOptionsOpen: false,
            terms: {value: false, valid: null},
            loyaltyCardNumber: {value: '', valid: null, requiredLength: 16},
            hasLoyaltyAccount: {value: undefined, valid: null},
            formInfo: {
                showPaymentForm: false
            }
        };

        this.handleApple();
    }

    componentDidUpdate() {
        this.handleApple();
    }

    handleApple() {
        if (!this.props.apple) return;

        delete fields.password;
        delete fields.passRepeat;
        fields.email.disabled = false;
    }
    
    onChange(prop, value) {
        const field = fields[prop];
        const { formatterFn } = field;
        if (formatterFn) {
            value = formatterFn(value);
        }
        this.setState((state) => ({[prop]: Object.assign({}, state[prop], {value})}), () => this.validate(prop));
    }

    onSubmit(e) {
        e.preventDefault();

        if (!this.validateForm()) {
            return this.setState(() => ({validated: true, valid: false}));
        }

        if (this.state.ieOption.value && this.state.ieOption.value.price) {
            return this.setState(state => ({
                formInfo: {
                    ...state.formInfo,
                    showPaymentForm: true
                }
            }));
        }

        return this.props.onSubmit(this.getRegisterParams());
    }

    getRegisterParams() {
        const result:{ [key:string]: any } = {
            email: this.state.email.value,
            first_name: this.state.firstName.value,
            f_last_name: this.state.lastName.value,
            m_last_name: this.state.motherLastName.value,
            phone: this.state.phone.value,
            birth_date: this.state.birthDate.value,
            gender: this.state.gender.value,
            cinema_id: this.state.cinema.value,
            password: this.state.password.value,
            token: this.props.info.token,
            terms: this.state.terms.value,
        };

        if (this.props.isSignUpOptionRequired) {
            if (this.state.hasLoyaltyAccount.value) {
                result.sign_up_option = 'already_member';
                result.loyalty_card_number = this.loyaltyCardNumber.value;
            } else {
                result.sign_up_option = this.state.ieOption.value.id;
                result.sign_up_option_price = this.state.ieOption.value ? this.state.ieOption.value.price : 0;
            }
        }

        return result;
    }

    validateForm() {
        const requiredFields = Object.keys(fields).filter(field => fields[field].required);

        let validForm = true;
    
        requiredFields.forEach(prop => {
            const {valid, validationError} = this.validateField(prop);
            this.setState((state) => ({[prop]: Object.assign({}, state[prop], {valid, validationError})}));
            validForm = !!(validForm && valid);
        });

        const termsValid = this.state.terms.value === true;

        this.setState(state => ({
            terms: { ...state.terms, valid: termsValid }
        }));

        const loyaltyValid = this.validateLoyaltyOptions();

        validForm = validForm && termsValid && loyaltyValid;

        return validForm;
    }

    validate (prop) {
        const {valid, validationError} = this.validateField(prop);
        this.setState((state) => ({[prop]: Object.assign({}, state[prop], {valid, validationError})}));
    }

    validateField(prop) {
        const {value} = this.state[prop];
        const {validationFns,validationMessage} = fields[prop];
        const required = true;
        let msg;
        let valid = true;
    
        if ((!validationFns || !validationFns.length) || (!value && !required)) {
            return {valid: null, validationError: ''};
        }
    
        validationFns && validationFns.every((fn, i) => {
            const v = fn(value);
            valid = valid && v;
            if (!v && Array.isArray(validationMessage)) {
                msg = validationMessage[i];
                return false;
            }
            return true;
        });
      
        if (valid && prop === 'passRepeat') {
            valid = this.state.password.value === this.state.passRepeat.value;
            msg = valid ? '' : 'La contraseña no coincide.'
        }

        const validationError = valid ? '' : (msg || validationMessage);
    
        return {valid, validationError};
    }

    validateLoyaltyOptions() {
        if (!this.props.isSignUpOptionRequired) {
            return true;
        }

        const isChoiceValid = null !== this.state.hasLoyaltyAccount.value;
        const isSignUpOptionValid = false === this.state.hasLoyaltyAccount.value
            ? this.state.ieOption.value !== null
            : null;
        const isCardNumberValid = true === this.state.hasLoyaltyAccount.value
            ? this.validateLoyaltyCardNumber()
            : null;

        this.setState(state => ({
            hasLoyaltyAccount: { ...state.hasLoyaltyAccount, valid: isChoiceValid },
            ieOption: { ...state.ieOption, valid: isSignUpOptionValid },
        }));

        return isChoiceValid !== false
            && isSignUpOptionValid !== false
            && isCardNumberValid !== false;
    }

    onCinemaChange(cinemaId) {
        this.setState(state => ({ cinema: { ...state.cinema, value: cinemaId } }));
    }

    onIEOptionSelect(option) {
        // Clear selected options
        if (!option) {
            this.setState(() => ({
                ieOption: { value: null, valid: false },
                ieOptionsOpen: true
            }));
            return;
        }

        if (option.group) {
            return;
        }

        this.setState(state => ({
            ieOption: Object.assign({}, {value: option, valid: true}),
            ieOptionsOpen: false
        }));
    }

    onIEOptionsClose() {
        this.setState(state => ({ieOptionsOpen: false}));
    }

    onIEOptionsOpen() {
        this.setState(state => ({ieOptionsOpen: true}));
    }

    getIeOptionName() {
        if (!this.state.ieOption.value) return '';
        return this.state.ieOption.value.name;
    }

    onTermsChange(checked) {
        this.setState(state => ({terms: {value: checked, valid: checked === true}}));
    }

    userIsLoyaltyMember() {
        return !!this.state.hasLoyaltyAccount.value;
    }

    get loyaltyCardNumber() {
        return this.state.loyaltyCardNumber;
    }

    validateLoyaltyCardNumber() {
        const { value } = this.loyaltyCardNumber;
        const valid = value && validators.validateIeCode(value);

        this.setState(state => ({
            loyaltyCardNumber: { ...state.loyaltyCardNumber, valid }
        }));

        return valid;
    }

    onLoyaltyCardNumberChange(value) {
        const formattedValue = formatIeCode(value);

        this.setState(state => ({
            loyaltyCardNumber: { ...state.loyaltyCardNumber, value: formattedValue }
        }), this.validateLoyaltyCardNumber);
    }

    onHasLoyaltyAccountChange(value) {
        this.setState(state => {
            const newState: Partial<State> = {
                hasLoyaltyAccount: { ...state.hasLoyaltyAccount, value },
            };

            if (value === true) {
                newState.ieOption = {value: null, valid: true};
            }

            return newState;
        }, this.validateLoyaltyOptions);
    }

    render() {
        return <React.Fragment>
            {this.renderContent()}
            {this.props.paymentGateway && this.state.formInfo.showPaymentForm ? this.renderPaymentForm() : ''}
        </React.Fragment>
    }

    renderPaymentForm() {
        return <PaymentSidebar
            transactionData={{context: CHECKOUT_CONTEXT_SIGN_UP, data: this.getRegisterParams()}}
            cash={this.state.ieOption.value.price}
            ccRequired={true}
            fullWidth={true}
            method={paymentMethods.creditCard}
            paymentGateway={this.props.paymentGateway}
            userInfo={this.getRegisterParams()}
            onCancel={this.onPaymentCancel}
            onSubmit={this.props.onSubmit}
            context={CHECKOUT_CONTEXT_SIGN_UP}
        />
    }

    onPaymentCancel() {
        return this.setState(state => ({
            formInfo: {
                ...state.formInfo,
                showPaymentForm: false
            }
        }));
    }

    renderContent() {
        return <React.Fragment>
            <div className="row">
                <form noValidate onSubmit={this.onSubmit} className={this.state.validated ? 'was-validated' : ''} style={{width:'100%'}}>
                    {Object.keys(fields).map(fieldName => {
                        const field = fields[fieldName];
                        const state = this.state[fieldName];
                        const Element = field.type === 'password-row' ? FieldPasswordRow : FieldRow

                        return (
                            <div key={fieldName} className='col-md-12'>
                                <Element label={field.label} placeholder={field.placeholder} type={field.type === 'password-row' ? 'password' : field.type}
                                        onChange={(e) => this.onChange(fieldName, e.target.value)}
                                        onBlur={() => this.validate(fieldName)}
                                        onClick={field.onClick}
                                        value={state.value}
                                        valid={state.valid}
                                        validationError={state.validationError}
                                        inputProps={field.inputProps || {}}
                                        choices={field.choices || (field.getChoicesMethod && field.getChoicesMethod(this.props, this.state, fieldName, state.value))}
                                        id={field.id}
                                        required={field.required}
                                        expanded={field.expanded}
                                        disabled={field.disabled}
                                />
                            </div>
                        );
                    })}

                    {this.props.isSignUpOptionRequired && (<div className='col-md-12'>
                        <LoyaltyOptionsRow className="form-group form-group--label-helper">
                            <ChoicesGroupLabel
                                label="Cinemex Loop"
                                required
                            />

                            <FieldRow label='Seleccionar beneficio de bienvenida' type="radio" onChange={() => this.onHasLoyaltyAccountChange(false)} checked={false === this.state.hasLoyaltyAccount.value}
                                valid={this.state.hasLoyaltyAccount.valid} validationError={this.props.validationError} name="loop-select" />

                            {false === this.state.hasLoyaltyAccount.value && (
                                <LoyaltySubOptionRow>
                                    <BenefitRow onClick={this.onIEOptionsOpen}>
                                        <FieldRow required label='Beneficio de bienvenida' placeholder='Selecciona tu beneficio de bienvenida de Cinemex Loop'
                                            value={this.getIeOptionName()}
                                            valid={this.state.ieOption.valid} disabled
                                            validationError={this.state.ieOption.valid !== true ? 'Selecciona una opción' : null}
                                            icon='fal fa-chevron-right'
                                        />
                                    </BenefitRow>
                                </LoyaltySubOptionRow>
                            )}
                            
                            <FieldRow label='Ya soy miembro de Cinemex Loop o cuento con una tarjeta' type="radio" onChange={() => this.onHasLoyaltyAccountChange(true)} checked={true === this.state.hasLoyaltyAccount.value}
                                valid={this.state.hasLoyaltyAccount.valid} validationError={this.props.validationError} name="loop-select" />

                            {!!this.state.hasLoyaltyAccount.value && (
                                <LoyaltySubOptionRow>
                                    <FieldRow
                                        type="text"
                                        label="Ingresa tu número de tu tarjeta Cinemex Loop"
                                        value={this.loyaltyCardNumber.value}
                                        minLength={this.loyaltyCardNumber.requiredLength}
                                        maxLength={this.loyaltyCardNumber.requiredLength}
                                        required
                                        valid={this.loyaltyCardNumber.valid}
                                        validationError={this.loyaltyCardNumber.valid || 'Ingresa un número de tarjeta válido.'}
                                        onChange={(e) => this.onLoyaltyCardNumberChange(e.target.value)}
                                        onBlur={this.validateLoyaltyCardNumber}
                                    />
                                </LoyaltySubOptionRow>
                            )}

                            {!this.state.hasLoyaltyAccount.valid && <FieldValidationMessage message="Indica si ya eres miembro de Cinemex Loop"/>}
                        </LoyaltyOptionsRow>
                    </div>)}
                    
                    <div className="col-md-12">
                        <SignUpTermsCheckbox checked={this.state.terms.value} onChange={this.onTermsChange}
                            valid={this.state.terms.value === true}
                            validationError={this.state.terms.value !== true ? 'Debes aceptar los términos y condiciones' : ''}
                            />
                    </div>
                    <div className="col-12 mt-5">
                        <Button className="mb-2" submit primary block>{!this.state.hasLoyaltyAccount.value && this.state.ieOption.value && this.state.ieOption.value.price > 0 ? 'Ir al pago' : 'Registrarme'}</Button>
                    </div>
                </form>
            </div>
            <SignUpManualIEOptions onCinemaChange={this.onCinemaChange} onIEOptionSelect={this.onIEOptionSelect} close={this.onIEOptionsClose} visible={this.state.ieOptionsOpen} />
        </React.Fragment>;
    }

}

const mapStateToProps = (state, ownProps) => ({
    paymentGateway: getIeSignUpPaymentGateway(state),
    ieOptions: getIeSignUpOptions(state),
    isSignUpOptionRequired: ownProps.info && !ownProps.info.has_loyalty_account
});

const mapDispatchToProps = {
    fetchIeSignUpOptions,
};
  
export default connect(mapStateToProps, mapDispatchToProps)(SignUpManualUserInfo);